import { CargoUnitsApi } from '@operations/app/api'
import { createApiClient } from '@operations/app/http-client'

class CargoUnitService {
  httpClient = createApiClient(CargoUnitsApi)

  async getContainerHistoryAdditionalData(gangIs: number[], shiftIds: number[]) {
    const { data } = await this.httpClient.getContainerHistoryAdditionalData(gangIs, shiftIds)
    return data
  }
}

const cargoUnitService = new CargoUnitService()

export default cargoUnitService
